import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Behaves like Angular's built-in PreloadAllModules, except it skips any
 * route whose data explicitly opts out with `{ preload: false }`.
 *
 * This exists because PreloadAllModules was preloading the admin
 * dashboard/login bundles on every visit to the public site — dead weight
 * for the ~100% of visitors who are never the site admin. Lighthouse
 * flagged this as unused JavaScript / main-thread work on the home page.
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data?.['preload'] === false) {
      return of(null);
    }
    return load();
  }
}
